import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import Gbtn from "../../../Components/buttons/Gbtn";
import DashNav from "../../../Components/DashNav/DashNav";
import EmployeeSVG from "../../../Components/SVGS/EmployeeSVG";
import { FiEdit } from "react-icons/fi";
import { deleteHomeData, deleteRecentNewsNoti, getAllClients, getAllHomeData, getAllRecentNewsNoti } from "../../../api";
import { RiSignalWifiErrorLine, RiDeleteBin6Line } from "react-icons/ri";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../Components/LoadingSpinner/LoadingSpinner";
import { Enums } from "../../../Enums";
import ModalComp from "../../../Components/modal/ModalComp";
import { HiHome } from "react-icons/hi";

export default function HomeScreen() {
    const icon = () => {
        return <HiHome size="28" fill="#DF2F35" />;
    };

    const location = useLocation();
    const CurrPage =
        location.state && location.state ? location.state.page : null;

    const navigate = useNavigate("");

    const [page, setPage] = useState(CurrPage !== null ? CurrPage : 1);
    const [limit, setLimit] = useState(10);
    const [totalRecords, setTotalRecords] = useState(10);
    const [dataContent, setDataContent] = useState([]);
    const [isLoading, setisLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [paginationDisplay, setPaginationDisplay] = useState("block");
    const [err, setErr] = useState(false);
    const [searchString, setSearchString] = useState("");


    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        fetchData(page);
    }, []);

    useEffect(() => {
        const delay = setTimeout(() => {
            if (searchString.trim() !== "") fetchData(page, searchString);
        }, 1500);
        return () => {
            clearTimeout(delay);
        };
    }, [searchString]);

    const fetchData = (pageNumber, searchTxt) => {
        setisLoading(true);
        setErr(false);
        getAllHomeData(limit, pageNumber, searchTxt)
            .then(({ data }) => {
                setisLoading(false);
                if (data.error_code == 0) {
                    setDataContent(data.result);
                    setTotalRecords(data.total_records);
                    setPaginationDisplay("block");
                    setPage(pageNumber);
                } else if (data.error_code === 2) {
                    setDataContent(data.result);
                    setErrorMsg(data.message);
                } else {
                    setErr(true);
                    setErrorMsg(data.message);
                }

            })
            .catch((err) => {
                console.log("err", err);
                setErr(true);
                setPaginationDisplay("none");
                setErrorMsg(`Network Error! ${err.message}`);
                setisLoading(false);
            });
    };

    const handlePageChange = (pageNumber) => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        if (pageNumber >= 1) {
            fetchData(pageNumber, searchString);
        }
    };

    const handleSearch = (e) => {
        setSearchString(e.target.value);
        if (e.target.value === "") {
            fetchData(page);
        }
    };

    return (
        <>
            <div className="mainDashView">
                <div>
                    <DashNav svg={icon} DashboardNavText="Home" />
                </div>

                <div className="dashPanel border-lt-Gray">
                    <div className="r-ViewBar">
                        <div className="r-ViewBar2">
                            <div>
                                <input
                                    type="search"
                                    value={searchString}
                                    onChange={handleSearch}
                                    placeholder="Search"
                                    className="rolesSearch"
                                />
                            </div>
                        </div>
                        <div className="r-View-btn">
                            <Gbtn
                                text="Add"
                                color="#DF2F35"
                                radius="5px"
                                width="200px"
                                func={() =>
                                    navigate("/dashboard/home/add")}
                            />
                        </div>
                    </div>
                    {isLoading ? (
                        <LoadingSpinner />
                    ) : err ? (
                        <div className="network-err-msg">
                            <RiSignalWifiErrorLine /> {errorMsg}
                        </div>
                    ) : dataContent && dataContent ? (
                        <div className="tableContainer">
                            <table className="roleViewTable" style={{ width: '100%' }}>
                                <thead>
                                    <tr>
                                        <th>
                                            Actions
                                        </th>
                                        <th>Title</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dataContent.map((data) => (
                                        <Rows data={data} currentPage={page} setDataContent={id => {
                                            let newData = dataContent?.filter(item => item.id != id);
                                            setDataContent(newData)
                                        }} />
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="network-err-msg">{errorMsg}</div>
                    )}
                    <div className="paginationDiv" style={{ display: paginationDisplay }}>
                        <Pagination
                            activePage={page}
                            itemsCountPerPage={limit}
                            totalItemsCount={totalRecords}
                            pageRangeDisplayed={3}
                            onChange={(pageNumber) => {
                                handlePageChange(pageNumber);
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
const Rows = ({ data, currentPage, setDataContent }) => {
    const navigate = useNavigate();
    let DataId = data.id;
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isModalLoading, setIsModalLoading] = useState(false)
    const [err, setErr] = useState(false)
    const editRole = () => {
        navigate("/dashboard/home/edit", {
            state: { editData: data, page: currentPage },
        });
    };
    const delRole = () => {
        setErr(false)
        setIsModalLoading(true)
        deleteHomeData({ id: data?.id }).then(({ data }) => {
            setIsModalLoading(false)
            if (data.error_code == 0 || data.error_code == 1) {
                setDataContent(DataId)
                setIsModalOpen(false)
            }
            else if (data.error_code == 2) {
                setErr(true)
            }
            else {
                setErr(true)
            }
        }).catch(err => {

            setIsModalLoading(false)
            setErr(true);
        })
    };



    return (
        <>
            <ModalComp isVisible={isModalOpen} setIsVisible={setIsModalOpen} onCnfrm={delRole} isLoading={isModalLoading} isErr={err} />
            {data && data ? (
                <tr>
                    <td
                        style={{
                            minWidth: "50px",
                        }}
                    >
                        <div style={{ display: "flex", justifyContent: 'center', margin: "0 15px" }}>
                            <button onClick={editRole} className="Actionbtn editBtn">
                                <FiEdit />
                            </button>
                            <button onClick={() => setIsModalOpen(true)} className="Actionbtn delBtn">
                                <RiDeleteBin6Line />
                            </button>
                        </div>
                    </td>

                    <td className="break-line-100">{data?.name?.length > 150 ? data?.name.substring(0, 146) + '...' : data?.name}</td>
                    <td className="break-line-200">{data?.description?.length > 160 ? data?.description.substring(0, 156) + '...' : data?.description}</td>
                </tr>
            ) : null}
        </>
    );
};


